import React, { useState, useRef } from "react";
import FurnitureItem from "./furnitureItem";
import Chair from "./chair";
import "./style.css";
import "animate.css";

function Furniture({ furniture, chair, furnitureChairRef }) {
  const [showAllTables, setShowAllTables] = useState(false);
  const [showAllChairs, setShowAllChairs] = useState(false);

  const tablesToShow = showAllTables ? furniture : furniture.slice(0, 4); // показываем 6 по умолчанию
  const chairsToShow = showAllChairs ? chair : chair.slice(0, 4);

  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        {/* Заголовок секции столов */}
        <div className="text-center mb-16">
          <h1
            className="
            text-4xl sm:text-5xl md:text-6xl lg:text-7xl 
            font-extrabold tracking-tight
            bg-gradient-to-r from-gray-900 via-[#A1C349] to-gray-900
            bg-clip-text text-transparent
          "
          >
            Столдор
          </h1>
        </div>

        {/* Сетка столов */}
        <div
          className="
          grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 
          xl:grid-cols-4 gap-6 md:gap-8 lg:gap-10
          animate__animated animate__fadeInUp animate__delay-1s
        "
        >
          {tablesToShow.map((item) => (
            <div
              key={item.id}
              className="
      group relative rounded-2xl
      bg-white shadow-lg hover:shadow-2xl
      transition-all duration-500 ease-out
      hover:-translate-y-3
    "
            >
              {/* === НОВАЯ АКЦИОННАЯ МЕТКА === */}
              {item.isBestseller && (
                <div
                  className="
                  absolute -top-2 -right-2
                  bg-gradient-to-br from-[#A1C349] to-[#8CAF3D] z-50
                  text-white text-xl font-bold
                  px-5 py-2 rounded-xl shadow-lg
                  animate-pulse-slow"
                >
                  Эң көп сатылган
                </div>
              )}

              {/* Альтернативная метка — если хочешь "Акция" или "Жаңы" */}
              {item.isNew && (
                <div
                  className="
        absolute top-0 right-0 z-20
        bg-gradient-to-r from-red-500 to-pink-600
        text-white font-bold text-sm uppercase tracking-wider
        px-8 py-3 rounded-bl-xl shadow-lg
      "
                >
                  Жаңы
                </div>
              )}

              {item.discount && (
                <div
                  className="
        absolute top-3 right-3 z-20
        bg-red-600 text-white font-bold text-lg
        px-4 py-2 rounded-full shadow-lg
      "
                >
                  -{item.discount}%
                </div>
              )}

              {/* Сама карточка товара */}
              <FurnitureItem furniture={item} />
            </div>
          ))}
        </div>

        {/* Кнопка показать больше / свернуть */}
        <div className="flex justify-center mt-12 md:mt-16">
          <button
            onClick={() => setShowAllTables(!showAllTables)}
            className="
              group relative overflow-hidden
              flex items-center gap-3 px-10 py-5
              bg-[#A1C349] hover:bg-[#8CAF3D]
              text-white font-semibold text-lg
              rounded-full shadow-lg
              transition-all duration-400
              hover:shadow-[#A1C349]/40 hover:scale-[1.03]
              active:scale-95
            "
          >
            <span className="relative z-10">
              {showAllTables ? "Жабуу" : "Бүт коллекцияны көрүү"}
            </span>

            <span className="relative z-10 text-2xl transition-transform duration-400 group-hover:rotate-180">
              <ion-icon
                name={
                  showAllTables ? "chevron-up-outline" : "chevron-down-outline"
                }
              ></ion-icon>
            </span>

            {/* Фон-эффект при наведении */}
            <span
              className="
              absolute inset-0 
              bg-gradient-to-r from-[#A1C349] to-[#bedb76]
              opacity-0 group-hover:opacity-100
              transition-opacity duration-500
            "
            ></span>
          </button>
        </div>

        {/* Разделитель между секциями */}
        <div className="h-px bg-gray-200 my-20 md:my-28"></div>

        {/* Заголовок секции стульев */}
        <div className="text-center mb-16" ref={furnitureChairRef}>
          <h1
            className="
            text-4xl sm:text-5xl md:text-6xl lg:text-7xl 
            font-extrabold tracking-tight
            bg-gradient-to-r from-gray-900 via-[#A1C349] to-gray-900
            bg-clip-text text-transparent
          "
          >
            Стулдар
          </h1>
        </div>

        {/* Сетка стульев */}
        <div
          className="
          grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 
          xl:grid-cols-4 gap-6 md:gap-8 lg:gap-10
          animate__animated animate__fadeInUp
        "
        >
          {chairsToShow.map((item) => (
            <div
              key={item.id}
              className="
                group relative overflow-hidden rounded-2xl
                bg-white shadow-lg hover:shadow-2xl
                transition-all duration-500 ease-out
                hover:-translate-y-2
              "
            >
              <Chair chair={item} />
            </div>
          ))}
        </div>

        {/* Кнопка показать больше / свернуть для стульев */}
        <div className="flex justify-center mt-12 md:mt-16">
          <button
            onClick={() => setShowAllChairs(!showAllChairs)}
            className="
              group relative overflow-hidden
              flex items-center gap-3 px-10 py-5
              bg-[#A1C349] hover:bg-[#8CAF3D]
              text-white font-semibold text-lg
              rounded-full shadow-lg
              transition-all duration-400
              hover:shadow-[#A1C349]/40 hover:scale-[1.03]
              active:scale-95
            "
          >
            <span className="relative z-10">
              {showAllChairs ? "Жабуу" : "Бүт коллекцияны көрүү"}
            </span>

            <span className="relative z-10 text-2xl transition-transform duration-400 group-hover:rotate-180">
              <ion-icon
                name={
                  showAllChairs ? "chevron-up-outline" : "chevron-down-outline"
                }
              ></ion-icon>
            </span>

            <span
              className="
              absolute inset-0 
              bg-gradient-to-r from-[#A1C349] to-[#bedb76]
              opacity-0 group-hover:opacity-100
              transition-opacity duration-500
            "
            ></span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Furniture;
